export const WEEK_DAYS = [
  {
    id: 1,
    translate: 'COMMON.WEEKDAYS.MN',
  },
  {
    id: 2,
    translate: 'COMMON.WEEKDAYS.TH',
  },
  {
    id: 3,
    translate: 'COMMON.WEEKDAYS.WD',
  },
  {
    id: 4,
    translate: 'COMMON.WEEKDAYS.TR',
  },
  {
    id: 5,
    translate: 'COMMON.WEEKDAYS.FR',
  },
  {
    id: 6,
    translate: 'COMMON.WEEKDAYS.ST',
  },
  {
    id: 7,
    translate: 'COMMON.WEEKDAYS.SN',
  },
];
